<template>
	<div :class="{ 'google-btn': true, hide: !showGoogleBtn }">
		<span class="google-btn-wrap" @click="googleAuth" v-if="showGoogleBtn">
			<svg
				width="46px"
				height="46px"
				viewBox="0 0 46 46"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
			>
				<!-- Generator: Sketch 3.3.3 (12081) - http://www.bohemiancoding.com/sketch -->
				<title>btn_google_light_normal_ios</title>
				<desc>Created with Sketch.</desc>
				<defs>
					<filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-1">
						<feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
						<feGaussianBlur stdDeviation="0.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
						<feColorMatrix
							values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.168 0"
							in="shadowBlurOuter1"
							type="matrix"
							result="shadowMatrixOuter1"
						></feColorMatrix>
						<feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
						<feGaussianBlur stdDeviation="0.5" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
						<feColorMatrix
							values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.084 0"
							in="shadowBlurOuter2"
							type="matrix"
							result="shadowMatrixOuter2"
						></feColorMatrix>
						<feMerge>
							<feMergeNode in="shadowMatrixOuter1"></feMergeNode>
							<feMergeNode in="shadowMatrixOuter2"></feMergeNode>
							<feMergeNode in="SourceGraphic"></feMergeNode>
						</feMerge>
					</filter>
					<rect id="path-2" x="0" y="0" width="40" height="40" rx="2"></rect>
				</defs>
				<g id="Google-Button" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
					<g id="9-PATCH" sketch:type="MSArtboardGroup" transform="translate(-608.000000, -160.000000)"></g>
					<g id="btn_google_light_normal" sketch:type="MSArtboardGroup" transform="translate(-1.000000, -1.000000)">
						<g id="button" sketch:type="MSLayerGroup" transform="translate(4.000000, 4.000000)" filter="url(#filter-1)">
							<g id="button-bg">
								<use fill="#FFFFFF" fill-rule="evenodd" sketch:type="MSShapeGroup" xlink:href="#path-2"></use>
								<use fill="none" xlink:href="#path-2"></use>
								<use fill="none" xlink:href="#path-2"></use>
								<use fill="none" xlink:href="#path-2"></use>
							</g>
						</g>
						<g id="logo_googleg_48dp" sketch:type="MSLayerGroup" transform="translate(15.000000, 15.000000)">
							<path
								d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"
								id="Shape"
								fill="#4285F4"
								sketch:type="MSShapeGroup"
							></path>
							<path
								d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"
								id="Shape"
								fill="#34A853"
								sketch:type="MSShapeGroup"
							></path>
							<path
								d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"
								id="Shape"
								fill="#FBBC05"
								sketch:type="MSShapeGroup"
							></path>
							<path
								d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"
								id="Shape"
								fill="#EA4335"
								sketch:type="MSShapeGroup"
							></path>
							<path d="M0,0 L18,0 L18,18 L0,18 L0,0 Z" id="Shape" sketch:type="MSShapeGroup"></path>
						</g>
						<g id="handles_square" sketch:type="MSLayerGroup"></g>
					</g>
				</g>
			</svg>

			<span class="label" v-html="login ? 'Sign in with Google' : 'Sign up with Google'"></span>
		</span>
		<p class="error-message" v-if="errorMessage">{{ errorMessage }}</p>
	</div>
</template>

<script>
import { mapMutations } from "vuex";
import ApiService from "./../services/api.service";
import Loading from "./Loading.vue";
import general from './../utils/general'
export default {
	name: "GoogleSignin",
	components: { Loading },
	props: {
		login: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		showGoogleBtn(newVal) {
			this.$emit("update:showGoogleBtn", newVal);
		}
	},
	data() {
		return {
			response: "",
			loading: "",
			responseType: "",
			gscDone: false,
			showGoogleBtn: false,
			errorMessage: "",
		};
	},
	computed: {

	},
	methods: {
		...mapMutations("general", ["updateLoadingText"]),
		googleAuth() {
			let t = this,
			client = google.accounts.oauth2.initCodeClient({
				client_id: "890943789055-8fjnpo8vm32pq0ek3tup06ubgdbuublk.apps.googleusercontent.com",
				scope: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
				ux_mode: "popup",
				callback: (authResult) => {
					if (authResult.error) {
						console.error(authResult.error, authResult);
						return;
					}

					let info = {
						code: authResult.code,
						type: t.login ? "signin" : "signup",
						meta: {}
					};

					t.response = "";

					t.updateLoadingText(true);

					const queryString = window.location.search;
					
					if ( queryString ) {

						const params = new URLSearchParams(queryString);

						params.forEach(function(value, key) {
							info.meta[key] = value;
						});

					}

					ApiService.post("google/token/login", info)
						.then(function(response) {
							t.errorMessage = '';
							t.gscDone = true;
							t.loading = "";
							t.$emit("success", response);
							t.updateLoadingText();
						})
						.catch(function(err) {
							t.responseType = "error";
							t.response = err.response.data.error;

							if (err.response.data.generic) {
								t.response = "There was an error connecting your account, please try again or click the message icon on the bottom right of the screen to get in touch with us.";
							}

							t.loading = "";
							t.$emit("error", t.response);
							t.errorMessage = t.response;
							t.updateLoadingText();
						});
				},
				error_callback(response) {
					t.errorHandler(response.type, response);
				},
			});

			try {
				client.requestCode();
			} catch (err) {
				console.log(err);
			}
		},
		errorHandler(type, output) {
			this.loading = "";
			this.responseType = "error";

			switch (type) {
				case "popup_closed_by_user":
				case "popup_closed":
				case "access_denied":
					this.response = "Something went wrong, did you close the window early?";

					break;

				case "popup_blocked_by_browser":
				case "popup_failed_to_open":
					this.response = "It looks like the Google popup was blocked by your browser. Please enable popups and try again.";

					break;

				default:
					this.response = "Sorry we are having a problem connecting your Google account, please get in touch.";

					if (!!output) {
						console.log("Google Connect Error", output);
						/*
						ApiService.post( 'google/auth-issue', { output: output } )
						.then( function() {})
						.catch( function() {});
						*/
					}
			}
			this.$emit('error', this.response);
			this.errorMessage = this.response;
		},
	},
	created() {},
	mounted() {
		this.showGoogleBtn = general.isDev();
		if ( this.showGoogleBtn ) {
			let scriptId = 'google-gsi',
				apiUrl = 'https://accounts.google.com/gsi/client';

			if ( !document.getElementById(scriptId) ) {

				let script = document.createElement('script');
				script.src = apiUrl;
				script.id = scriptId;
				script.onreadystatechange = script.onload = function () {
					if (!script.readyState || /loaded|complete/.test(script.readyState)) {
						setTimeout(function () {
							
						}, 500)
					}
				}
				document.getElementsByTagName('head')[0].appendChild(script)

			}
		}
	},
	beforeDestroy() {},
};
</script>

<style lang="less" scoped>
@import "./../assets/css/less/_settings.less";
.hide {
	display: none;
}
.error-message {
	background-color: @red;
	color: #fff;
	margin: 20px 0 0;
	padding: 10px;
	border-radius: 5px;
}
.google-btn {

	text-align: center;

	.label, svg {

		display: inline-block;
		vertical-align: text-top;

	}

	.label {

		padding: 2px 10px 6px 0;

	}

	.google-btn-wrap {

		display: inline-block;
		-webkit-box-shadow: 1px 1px 7px -4px #757575;
		-moz-box-shadow:1px 1px 7px -4px #757575;
		box-shadow: 1px 1px 7px -4px #757575;
		border-radius: 5px;
		height: 49px;
		cursor: pointer;
		padding: 0 0 0 2px;

		.label {

			color: #757575;
			font-weight: @bold;
			padding: 13px 12px 0 2px;

		}

		&:hover {

			background-color: #4285f4;

			.label {

				color: #fff;

			}

		}

	}

}
</style>
